import { Alert, Box, Card, CardContent, Snackbar, Typography } from '@mui/material';
import { useState } from 'react';
import PageScaffold from '../../../component/pageScaffold/PageScaffold';
import WhatsappConnection from '../../whatsapp';

// Conexão do WhatsApp único do sistema (admin da plataforma). É por este número que o
// sistema envia os avisos da aba Notificações aos tenants (celular do cadastro de cada um).
export default function AdminWhatsapp() {
    const [snackbar, setSnackbar] = useState({ open: false, message: '' });

    return (
        <PageScaffold links={[]} titlePageTarget={'WhatsApp do Sistema'}>
            <Box sx={{ width: '100%', maxWidth: 720, mx: 'auto', px: { xs: 2, md: 3 }, py: { xs: 2, md: 3 } }}>
                <Card variant="outlined">
                    <CardContent>
                        <Typography sx={{ fontSize: '15px', fontWeight: 700 }}>Número do sistema</Typography>
                        <Typography sx={{ fontSize: '12.5px', color: 'text.secondary', mt: 0.5 }}>
                            Este número envia os avisos de estoque, vendas e ordens de serviço para o celular cadastrado de cada empresa.
                        </Typography>
                        <WhatsappConnection
                            basePath="/admin/whatsapp"
                            onNotify={(message) => setSnackbar({ open: true, message })}
                        />
                    </CardContent>
                </Card>
            </Box>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => setSnackbar({ open: false, message: '' })}
            >
                <Alert severity="success" onClose={() => setSnackbar({ open: false, message: '' })}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </PageScaffold>
    );
}
